<template>
    <div class="app-container">
        <!-- 筛选条件 工具栏-->
        <div class="filter-container">
            <!-- 搜索 -->
            <el-input class="filter-item" size="small" v-model="search" placeholder="模糊查找" style="width:200px"></el-input>

            <el-button class="filter-item" size="mini" type="primary" style="float:right" @click="handleCreate">创建团队</el-button>
        </div>

        <!-- 表格 -->
        <el-table class="grayTableTile tableBox" v-loading="listLoading" size="small" :data="tableData" style="width:100%;">
            <el-table-column label="团队名称" min-width="150">
                <template  slot-scope="scope">
                   <span class="link" @click="handleDetails(scope.row)">{{scope.row.name}}</span>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" min-width="100">
                <template  slot-scope="scope">
                   <span>{{scope.row.name}}</span>
                </template>
            </el-table-column>

            <el-table-column label="创建人" min-width="120">
                <template  slot-scope="scope">
                   <span>{{scope.row.name}}</span>
                </template>
            </el-table-column>
            
            <el-table-column label="操作" min-width="100px">
                <template  slot-scope="scope">
                   <el-button type="text" style="color:#67C23A" @click="handleAddRole(scope.row)">添加角色</el-button>
                   <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                   <el-button type="text" style="color:#F56C6C" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" @pagination="handleFilter" style="margin-top:0" />

        <!-- 创建团队 -->
        <el-dialog class="dialog" :title="dialogType == 'add' ? '创建团队' : '编辑团队'" :visible.sync="dialogForm" width="500px">
            <el-form :model="teamForm" ref="teamForm" label-width="120px">
                <el-form-item label="名称：" prop="name" :rules="{ required: true, message: '请输入团队名称', trigger: ['change','blur'] }">
                    <el-input size="small" v-model="teamForm.name" placeholder="请输入团队的名称" style="width:80%"></el-input>
                </el-form-item>
            </el-form>

            <div class="dialog-butn-box" style="margin: 30px 0 0">
                <el-button size="small" @click="dialogForm = false">取 消</el-button>
                <el-button size="small" type="primary" :loading="dialogLoading" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 查看详情 -->
        <permis-info ref="permis"  @handleAddRoles="handleAddRole" @handleAddUser="handleAddUser"></permis-info>

        <!--右侧抽屉 穿梭框 添加角色 -->
        <transfer v-if="drawer" ref="transfer" :title="drawertitle" @getTransferList="getTransferList" @handleSave="handleSaveDrawer"></transfer>
    
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import PermisInfo from './components/permisInfo'
import Transfer from '@Sys~/views/fangwenkongzhi/components/transferCollapse'
export default {
    components:{Pagination, PermisInfo,Transfer},
    data(){
        return {
            search:'',

            listLoading:false,
            tableData:[
                {
                    name:'市场===='
                }
            ],
            total:1,
            listQuery:{
               pageNo:1,
               pageSize:20,
            },

            // 创建团队
            dialogForm:false,
            dialogType: 'add',
            teamForm: {},
            dialogLoading:false,

            // 右侧抽屉
            drawer: false,
            drawertitle: "",
            jueseinfo:{}
        }
    },

    methods: {
        // 获取数据
        getList() {
            this.listLoading = false
        },

        // 查询
        handleFilter() {
            this.listQuery.pageNo = 1
            this.getList()
        },

        // 创建团队
        handleCreate() {
            this.dialogForm = true
            this.dialogType = 'add'
            this.teamForm = {}
            this.$nextTick(()=>{
                this.$refs['teamForm'].clearValidate()
            })
        },

        // 编辑团队
        handleEdit(row) {
            this.dialogForm = true
            this.dialogType = 'edit'
            this.teamForm = JSON.parse(JSON.stringify(row))
            this.$nextTick(()=>{
                this.$refs['teamForm'].clearValidate()
            })
        },

        // 保存创建团队
        handleSave() {
            this.$refs['teamForm'].validate((valid) => {
                if (valid) {
                    
                    // this.$store.dispatch('user/getInfo')

                    // this.$store.dispatch('permission/generateRoutes').then(res => {
                    //     this.$router.addRoutes(res)
                    // })
                }
            })
        },

        // 删除团队
        handleDelete(row) {
            this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });

            }).catch(() => {});
        },

        // 查看详情
        handleDetails(row) {
            this.$refs['permis'].init(row)
        },

        // 添加角色
        handleAddRole(row) {
            this.drawer = true
            this.jueseinfo = row
            this.$nextTick(() => {
                this.drawertitle = "添加角色权限：" + row.name;
                this.$refs['transfer'].init("purview",row)
                this.$refs['transfer'].sourceList = [
                {
                    title: '', // Collapse 折叠面板 标题
                    name: '1', // Collapse 折叠面板 序号
                    checkStrictly: true, // 不关联
                    toSelectedList:{ // 待选数据
                        title: '待选', // 待选标题
                        search:'', 
                        disabledSearch: true,
                        treeload: true,
                        list:[]
                    },
                    selectedList: { // 已选数据
                        title: '已选',
                        search:'',
                        disabledSearch: true,
                        treeload: false,
                        rawList:[],
                        list:[]
                    }
                },
                ]
            })
        },

        // 添加用户
        handleAddUser(row) {
            this.drawer = true
            this.jueseinfo = row
            this.$nextTick(() => {
                this.drawertitle = "添加角色用户：" + row.title;

                this.$refs['transfer'].init("userGroup",row)

                this.$refs['transfer'].sourceList = [
                    {
                        title: '', // Collapse 折叠面板 标题
                        name: '1', // Collapse 折叠面板 序号
                        checkStrictly: true, // 不关联
                        toSelectedList:{ // 待选数据
                            title: '待选', // 待选标题
                            search:'', 
                            disabledSearch: true,
                            treeload: true,
                            list:[]
                        },
                        selectedList: { // 已选数据
                            title: '已选',
                            search:'',
                            disabledSearch: true,
                            treeload: false,
                            rawList:[],
                            list:[]
                        }
                    },
                ]
            })
        },

        // 获取 角色 或 用户列表
        getTransferList() {
            
        }
    }
}
</script>

<style lang="scss" scoped>
    .link{
        color: #46a6ff;
        cursor: pointer;
    }
</style>